import { Metadata } from '@cognite/sdk';
import type { ApproveButtonStateInput, Project } from '../types';

const areWorkStepsReady = (
  workStepsViewed: boolean,
  isWorkStepsResolved: boolean,
  isWorkStepsRevisioned: boolean
): boolean => {
  return workStepsViewed && isWorkStepsResolved && isWorkStepsRevisioned;
};

const isProjectReady = (isProjectResolved: boolean): boolean => {
  return isProjectResolved;
};

const isInBlockingState = (
  hasDraftSteps: boolean,
  isCommentsUnresolved: boolean
): boolean => {
  return hasDraftSteps || isCommentsUnresolved;
};

export const setDisableApproveProcedureButton = ({
  workStepsViewed,
  isWorkStepsResolved,
  isWorkStepsRevisioned,
  isProjectResolved,
  hasDraftSteps,
  isCommentsUnresolved,
}: ApproveButtonStateInput): boolean => {
  return (
    !areWorkStepsReady(
      workStepsViewed,
      isWorkStepsResolved,
      isWorkStepsRevisioned
    ) ||
    !isProjectReady(isProjectResolved) ||
    isInBlockingState(hasDraftSteps, isCommentsUnresolved)
  );
};

export const buildProjectMetadata = (project: Project): Metadata => ({
  procedureName: project.name || 'Test Procedure',
  status: project.status || 'compilation',
  ...(project.isNewReviewerCommentsFlow && {
    isNewReviewerCommentsFlow: String(project.isNewReviewerCommentsFlow),
  }),
});

export const checkIfNewReviewerCommentsFlow = (project: Project): boolean => {
  return project.isNewReviewerCommentsFlow || false;
};
